import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageTitle, statusColor } from "@/components/DashUI";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { AlertTriangle } from "lucide-react";

export default function LeadsAdmin() {
  const [leads, setLeads] = useState([]);
  useEffect(() => { api.get("/admin/leads").then((r) => setLeads(r.data)).catch(() => {}); }, []);
  return (
    <div>
      <PageTitle title="All Leads" subtitle="Every attributed opportunity across the network" />
      <Card className="overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="admin-leads-table">
            <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
              <tr>{["Lead ID", "Agent", "Service", "Area", "Payer", "Status", "Flags"].map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}</tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {leads.map((l) => (
                <tr key={l.id} className="hover:bg-slate-50" data-testid={`admin-lead-${l.id}`}>
                  <td className="px-4 py-3 font-mono text-xs text-slate-500">{l.lead_id}</td>
                  <td className="px-4 py-3 text-slate-600">{l.agent_name}</td>
                  <td className="px-4 py-3 text-slate-600">{l.service_category}</td>
                  <td className="px-4 py-3 text-slate-600">{l.geographic_area}, {l.state}</td>
                  <td className="px-4 py-3 text-slate-600">{l.payer_type}</td>
                  <td className="px-4 py-3"><Badge className={`${statusColor(l.status)} hover:${statusColor(l.status)}`}>{(l.status || "").replace(/_/g, " ")}</Badge></td>
                  <td className="px-4 py-3">
                    {l.compliance_flag && <AlertTriangle className="inline h-4 w-4 text-amberbrand" />}
                    {l.duplicate_flag && <span className="ml-1 text-xs font-semibold text-amberbrand">DUP</span>}
                  </td>
                </tr>
              ))}
              {leads.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-slate-400">No leads yet.</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
